// Dati strutturati (schema.org) del sito pubblico.
import { SITE_ORIGIN } from "./seo";

export const WEBSITE_ID = `${SITE_ORIGIN}/#website`;
export const ORG_ID = `${SITE_ORIGIN}/#organization`;

export const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": ORG_ID,
      name: "JOBTIMEHR",
      url: `${SITE_ORIGIN}/`,
      logo: `${SITE_ORIGIN}/brand/jobtimehr_white.png`,
      sameAs: ["https://piusostenibili.it"],
      founder: { "@type": "Person", name: "Marco Paparelli" },
      vatID: "IT05042811009",
      email: "info@jobtimehr.it",
      telephone: "+39 06 85301146",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Viale Regina Margherita, 46",
        postalCode: "00198",
        addressLocality: "Roma",
        addressRegion: "RM",
        addressCountry: "IT",
      },
    },
    {
      "@type": "WebSite",
      "@id": WEBSITE_ID,
      url: `${SITE_ORIGIN}/`,
      name: "JOBTIMEHR",
      inLanguage: "it-IT",
      publisher: { "@id": ORG_ID },
    },
    {
      "@type": "SoftwareApplication",
      name: "JOBTIMEHR",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      inLanguage: "it-IT",
      description:
        "Software HR per consulenti del lavoro e aziende: presenze, ferie, permessi, trasferte, welfare, formazione, parco auto e comunicazioni in un'unica piattaforma.",
      publisher: { "@id": ORG_ID },
    },
  ],
};

export const webPageJsonLd = ({ name, description, url }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name,
  description,
  url,
  inLanguage: "it-IT",
  isPartOf: { "@id": WEBSITE_ID },
});
